module.exports = __webpack_public_path__ + "static/media/check-your-email.c05cabbc.svg";